import {
  ACTION_TEMPLATE_CONFIG_RESET_FILE__REQUEST,
  ACTION_TEMPLATE_CONFIG_RESET_FILE__SUCCESS,
  ACTION_TEMPLATE_CONFIG_RESET_FILE__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_TEMPLATE_CONFIG_RESET_FILE__REQUEST:
    case ACTION_TEMPLATE_CONFIG_RESET_FILE__SUCCESS:
      return null;

    case ACTION_TEMPLATE_CONFIG_RESET_FILE__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
